import React, { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import api, { apiError } from "@/lib/api";
import { Brand } from "@/components/Brand";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token");
  const nav = useNavigate();
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    if (pw !== pw2) { setErr("Şifreler eşleşmiyor"); return; }
    setLoading(true); setErr("");
    try {
      await api.post("/auth/reset-password", { token, password: pw });
      toast.success("Şifreniz güncellendi. Giriş yapabilirsiniz.");
      nav("/login", { replace: true });
    } catch (e2) { setErr(apiError(e2.response?.data?.detail)); }
    finally { setLoading(false); }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#f8fafc] p-6">
      <form onSubmit={submit} className="fade-in w-full max-w-sm">
        <div className="mb-8"><Brand /></div>
        <h2 className="font-heading text-2xl font-bold text-[#0a192f]">Yeni Şifre Belirle</h2>
        {!token && <p className="mt-2 text-sm text-red-600">Geçersiz bağlantı.</p>}
        {err && <div className="mt-4 rounded-lg border border-red-200 bg-red-50 px-3 py-2 text-sm text-red-700">{err}</div>}
        <div className="mt-6 space-y-4">
          <div>
            <Label htmlFor="pw">Yeni Şifre</Label>
            <Input id="pw" type="password" required minLength={6} value={pw} onChange={(e) => setPw(e.target.value)}
              data-testid="reset-password-input" className="mt-1.5" />
          </div>
          <div>
            <Label htmlFor="pw2">Yeni Şifre (Tekrar)</Label>
            <Input id="pw2" type="password" required value={pw2} onChange={(e) => setPw2(e.target.value)}
              data-testid="reset-password-confirm-input" className="mt-1.5" />
          </div>
        </div>
        <Button type="submit" disabled={loading || !token} data-testid="reset-submit-button"
          className="mt-6 w-full bg-emerald-600 hover:bg-emerald-700">
          {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : "Şifreyi Güncelle"}
        </Button>
        <Link to="/login" className="mt-6 block text-center text-sm text-slate-500 hover:text-slate-700">Girişe dön</Link>
      </form>
    </div>
  );
}
